export default {
  navHome: "Home",
  navProducts: "Producten",
  navCases: "Toepassingscases",
  navAbout: "Over ons",
  deliverTo: "Leveren aan:",
  langCurrencyLabel: "Nederlands",
  localeLangTitle: "Taal instellen",
  localeLangDesc:
    "Selecteer uw voorkeurstaal. U kunt deze instelling op elk moment bijwerken.",
  language: "Taal",
  save: "Opslaan",
  coreProducts: "Creativiteit in de echte wereld mogelijk maken.",
  coreProductsDesc:
    "Van idee tot business �?YONGYUAN biedt UV-printers, kristalletiketprinters, hogesnelheids cilindrische printers, DTF- en DTG-printers en transformeert creativiteit in producten, merken en kansen.",
  scenariosTitle: "Oplossingen voor elk scenario",
  scenariosDesc:
    "Of u nu een merk opbouwt, een nevenactiviteit ontwikkelt of creatieve passies nastreeft, YONGYUAN biedt een oplossing op maat van uw behoeften.",
  scenarioStudio: "Studio",
  scenarioStudioDesc:
    "Hoogwaardige maatwerk, kleine serie prototyping en merkopbouw",
  scenarioRetail: "Merch retail",
  scenarioRetailDesc:
    "Verleng de verblijfstijd van klanten en verhoog de winkelomzet",
  scenarioMarket: "Pop-up markt",
  scenarioMarketDesc:
    "Maatwerk ter plaatse, verkoop van afgewerkte producten en extra inkomen",
  scenarioEnterprise: "Zakelijke maatwerk",
  scenarioEnterpriseDesc:
    "Batchmaatwerk, merchandise en zakelijke geschenken",
  scenarioEcommerce: "Livestream verkoop",
  scenarioEcommerceDesc:
    "Hitproduct samples, flexibele levering en snelle productlanceringen",
  scenarioStore: "E-commerce winkel",
  scenarioStoreDesc:
    "Winkelmaatwerk, hitmerchandise en gedifferentieerde operaties",
  scenarioFactory: "Fabrieksproductie",
  scenarioFactoryDesc:
    "Batchproductie, stabiele output en kostenefficiënte operaties",
  scenarioAdvertising: "Reclameproductie",
  scenarioAdvertisingDesc:
    "Belettering, displaymaterialen en evenementmateriaal",
  industries: "Industriële toepassingen",
  industriesDesc:
    "Digitale inkjetoplossingen voor kleurafdrukken in diverse sectoren.",
  applicationsTitle:
    "Ontgrendel veelzijdige materiaal- en kleurtoepassingen voor dagelijkse en commerciële behoeften.",
  applicationsDesc:
    "YONGYUAN UV-printapparatuur is ontworpen voor een breed scala aan materialen en processscenario's en ondersteunt zowel gepersonaliseerd maatwerk als grootschalige productie.",
  casesHeroDesc:
    "Meer dan 1200 brancetoepassingen en tienduizenden bedrukbare materialen — digitale printoplossingen voor uiteenlopende bedrijven.",
  casesBreadcrumbHome: "Home",
  casesBreadcrumbCenter: "Toepassingscases",
  casesEmpty: "Nog geen toepassingscases in deze categorie.",
  customerStoriesTitle: "Vertrouwd door klanten wereldwijd",
  customerStoriesSubtitle:
    "Echte installaties, echte klanten, echte printbedrijven in 172 landen.",
  customerStoriesStat1Value: "53.000+",
  customerStoriesStat1Label: "Geleverde printers",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "Landen bediend",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "Jaar ervaring",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "Technische ondersteuning",
  customerStoriesPlaceholder: "Klantfoto toevoegen",
  customerStoriesPhotoAlt: "YONGYUAN-klant met printer",
  servicePartnerTitle:
    "Maak kennis met het YONGYUAN serviceteam, uw creatieve partner",
  servicePartnerDesc:
    "Een wereldwijd servicenetwerk en professioneel ondersteuningssysteem om uw apparatuurprestaties en bedrijfsgroei te beschermen.",
  serviceSupportTitle: "Standaard ondersteuning",
  serviceSupportDesc:
    "Installatiebegeleiding, basistraining en dagelijkse gebruiksondersteuning voor betrouwbare werking.",
  servicePresaleTitle: "Pre-sales demo en advies",
  servicePresaleDesc:
    "Oplossingsdemonstraties en modelaanbevelingen afgestemd op uw toepassingsscenario's en capaciteitsvereisten.",
  serviceLifetimeTitle: "Levenslange technische ondersteuning",
  serviceLifetimeDesc:
    "Doorlopende technische respons en procesondersteuning voor uw langetermijn bedrijfsontwikkeling.",
  serviceCareTitle: "Upgrade naar YONGYUAN Care",
  serviceCareDamageTitle: "Bescherming tegen accidentele schade",
  serviceCareDamageDesc:
    "Een uitgebreider beschermingsplan om verliezen door onverwachte incidenten te verminderen.",
  serviceCareExchangeTitle: "Snelle inruilservice",
  serviceCareExchangeDesc:
    "Prioritaire snelle inruilregelingen onder in aanmerking komende voorwaarden om kapitaalherstel te versnellen.",
  viewProduct: "Producten bekijken",
  learnMore: "Meer informatie",
  catUv: "UV vlakbedprinter",
  catCylinder: "Cilindrische printer",
  catCrystal: "Kristalletiketprinter",
  catDtf: "DTF-printer",
  catDtg: "DTG-printer",
  companyName: "Shenzhen Yongyuan Technology Co., Ltd.",
  phone: "Telefoon: 17748697567 Manager Tang",
  email: "E-mail: sales@yongyuanprinter.com",
  copyright:
    "Copyright © 2012-2026 Shenzhen Yongyuan Technology Co., Ltd. Alle rechten voorbehouden",
  productsHeroTitle: "Producten",
  productsHeroDesc:
    "Volledig assortiment UV vlakbed-, cilindrische, kristalletiket-, DTF- en DTG-apparatuur voor diverse capaciteits- en toepassingsbehoeften.",
  productsBreadcrumbHome: "Home",
  productsBreadcrumbCenter: "Producten",
  productsEmpty: "Producten in deze categorie komen binnenkort.",
  productsQuoteTitle: "Oplossing en offerte aanvragen",
  productsQuoteDesc:
    "Deel uw toepassingsscenario's en capaciteitsvereisten en wij bevelen de juiste apparatuuroplossing aan.",
  productsContact: "Neem contact op",
  aboutHeroTitle: "Over Yongyuan",
  aboutHeroDesc:
    "23 jaar gericht op R&D en productie van UV-printapparatuur",
  productA23Subtitle: "Desktop 6-kleuren intelligente UV-printer",
  productA23Feature1: "A4 printformaat",
  productA23Feature2: "Intelligent inktleveringssysteem",
  productA23Feature3: "Infrarood automatische hoogtedetectie",
  productA35Subtitle: "Desktop 6-kleuren intelligente UV-printer",
  productA35Feature1: "A3+ printformaat",
  productA35Feature2: "Intelligent inktleveringssysteem",
  productA35Feature3: "Infrarood automatische hoogtedetectie",
  productA43Subtitle: "Flagship 8-kleuren intelligente UV-printer",
  productA43Feature1: "A3 printformaat",
  productA43Feature2: "Meerdere printkopconfiguraties",
  productA43Feature3: "Intelligent inktleveringssysteem",
  productA46Subtitle: "Flagship 8-kleuren intelligente UV-printer",
  productA46Feature1: "A2 printformaat",
  productA46Feature2: "Meerdere printkopconfiguraties",
  productA46Feature3: "Intelligent inktleveringssysteem",
  productA57Subtitle: "Flagship 8-kleuren intelligente UV-printer",
  productA57Feature1: "A2+ printformaat",
  productA57Feature2: "Meerdere printkopconfiguraties",
  productA57Feature3: "Intelligent inktleveringssysteem",
  productA69Subtitle: "Flagship 8-kleuren intelligente UV-printer",
  productA69Feature1: "A1 printformaat",
  productA69Feature2: "Meerdere printkopconfiguraties",
  productA69Feature3: "Intelligent inktleveringssysteem",
  productA1216Subtitle: "Flagship grootformaat UV vlakbedprinter",
  productA1216Feature1: "1200×1600cm printformaat",
  productA1216Feature2: "Meerdere printkopconfiguraties",
  productA1216Feature3: "Visueel positioneringssysteem",
  productA2513Subtitle: "Flagship grootformaat UV vlakbedprinter",
  productA2513Feature1: "2500×1300cm printformaat",
  productA2513Feature2: "Meerdere printkopconfiguraties",
  productA2513Feature3: "Visueel positioneringssysteem",
  productCylinderElfSubtitle: "360° hogesnelheids cilindrische printer",
  productCylinderElfFeature1: "360° printen",
  productCylinderElfFeature2: "Bekers en flessen maatwerk",
  productCylinderElfFeature3: "Snelle gereedschapswissel",
  productCupPlusSubtitle: "Multi-formaat beker- en flesprintoplossing",
  productCupPlusFeature1: "Multi-formaat gereedschappen",
  productCupPlusFeature2: "Hoge productie-efficiëntie",
  productCupPlusFeature3: "Stabiele output",
  productCrystal60Subtitle: "Kristalletiket print- en folie alles-in-één systeem",
  productCrystal60Feature1: "60cm breedte",
  productCrystal60Feature2: "Print- en folie-integratie",
  productCrystal60Feature3: "Efficiënt opnamesysteem",
  productCrystalC60UltraFeature1: "60 cm breedte",
  productCrystalC60UltraFeature2: "Goud/zilver/3D siliconen label opties",
  productCrystalC60UltraFeature3: "Massaproductie",
  productCrystal30Subtitle: "Compacte hoogprecisie kristalletiketprinter",
  productCrystal30Feature1: "Compacte precisieprint",
  productCrystal30Feature2: "Eenvoudige bediening",
  productCrystal30Feature3: "Gepersonaliseerd maatwerk",
  productDtf60Subtitle: "Witte inkt DTF transferprinter",
  productDtf60Feature1: "Witte inkt DTF transfer",
  productDtf60Feature2: "Rijke kleurlagen",
  productDtf60Feature3: "Kledingaccessoires",
  productDtfF20Subtitle: "Kleinste desktop witte inkt DTF-printer in de branche",
  productDtfF20Feature1: "A4-formaat",
  productDtfF20Feature2: "Kleine serie maatwerk",
  productDtfF20Feature3: "Intelligent inkt systeem",
  productDtfF30Subtitle: "Desktop witte inkt DTF-printer",
  productDtfF30Feature1: "A3-formaat",
  productDtfF30Feature2: "Enkele kop handmatig/automatisch optioneel",
  productDtfF30Feature3: "Intelligent inkt systeem",
  productDtfF30ProSubtitle: "Witte inkt DTF-printer",
  productDtfF30ProFeature1: "A3-formaat",
  productDtfF30ProFeature2: "Dubbele kop met automatische filmopname",
  productDtfF30ProFeature3: "Intelligent inkt systeem",
  productDtfF33Subtitle: "Witte inkt DTF-printer",
  productDtfF33Feature1: "A3-formaat",
  productDtfF33Feature2: "Enkele kop handmatig/automatisch optioneel",
  productDtfF33Feature3: "Intelligent inkt systeem",
  productDtfF70ProSubtitle: "70 cm breed formaat witte inkt DTF-printer",
  productDtfF70ProFeature1: "A2-formaat",
  productDtfF70ProFeature2: "2�? printkop opties",
  productDtfF70ProFeature3: "Automatisch in- en uitvoersysteem",
  productDtfF70ProFeature4: "Intelligente hervat-afdrukmodus",
  productDtf30Subtitle: "Compacte witte inkt DTF-printer",
  productDtf30Feature1: "Kleine serie maatwerk",
  productDtf30Feature2: "Nauwkeurige kleurreproductie",
  productDtf30Feature3: "Gebruiksvriendelijk",
  productDtgPrintSubtitle: "Digitale direct-naar-textiel printer",
  productDtgPrintFeature1: "Multi-materiaal direct printen",
  productDtgPrintFeature2: "Hoge doorvoer",
  productDtgPrintFeature3: "Stabiel en duurzaam",
  productDtg3250DSubtitle: "Enige DTF & DTG 2-in-1 model in de branche",
  productDtg3250DFeature1: "A3+ formaat",
  productDtg3250DFeature2: "DTF & DTG dual-process printen",
  productDtg3250DFeature3: "Intelligent inkt systeem",
  productDtg3646TSubtitle: "DTG-printer met dubbele station",
  productDtg3646TFeature1: "Continue productiemodus",
  productDtg3646TFeature2: "100% hogere productiviteit",
  productDtg3646TFeature3: "Intelligent inkt systeem",
  productDtgMaxSubtitle: "Industriële digitale DTG-printer",
  productDtgMaxFeature1: "Industriële capaciteit",
  productDtgMaxFeature2: "Stabiel en duurzaam",
  productDtgMaxFeature3: "Continue werking",
  app01Title: "Telefoonhoesjes",
  app02Title: "Golfballen",
  app03Title: "Stenen platen",
  app04Title: "Balpennen",
  app05Title: "Brillenetuis",
  app06Title: "Houtsneden",
  app07Title: "Drankblikjes",
  app08Title: "Toetsenborden",
  app09Title: "Thermosbekers",
  app10Title: "Bagage",
  app11Title: "Acrylproducten",
  app12Title: "Notitieboeken",
  app13Title: "Badges",
  app14Title: "Leren kaarthouders",
  app15Title: "Identificatieplaatjes",
  app16Title: "Glaskunst",
  appDtgCase01: "T-shirts",
  appDtgCase02: "Hoodies",
  regionCn: "China",
  regionUs: "Verenigde Staten",
  regionGb: "Verenigd Koninkrijk",
  regionDe: "Duitsland",
  regionAe: "VAE",
  regionIn: "India",
  regionJp: "Japan",
  regionVn: "Vietnam",
  regionBr: "Brazilië",
  regionAu: "Australië",

  // synced from en
    uiClose: "Close",
    carouselPrev: "Previous product",
    carouselNext: "Next product",
    heroSlidePrev: "Previous slide",
    heroSlideNext: "Next slide",
    heroSlideDot: "Go to slide {n}",
    customerStoriesTrustedTitle: "Trusted Worldwide",
    customerStoriesBadge: "{count} international customer photos showcased",
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germany",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spain",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Saudi Arabia",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "South Korea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Netherlands",
    customerStoryCountrySweden: "Sweden",
    customerStoryCountrySouthAfrica: "South Africa",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "United States",
    customerStoryCaption01: "USA�?090 UV Printer",
    customerStoryCaption02: "Germany｜F33 DTF Printer",
    customerStoryCaption03: "Thailand�?250 UV Printer",
    customerStoryCaption04: "Spain�?250 UV Printer",
    customerStoryCaption05: "Brazil�?030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Saudi Arabia�?030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "South Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan�?030 UV Printer",
    customerStoryCaption12: "Mexico�?060 UV Printer",
    customerStoryCaption13: "Argentina�?060 UV Printer",
    customerStoryCaption14: "Philippines�?090 UV Printer",
    customerStoryCaption15: "Indonesia�?030 UV Printer",
    customerStoryCaption16: "Netherlands�?030 UV Printer",
    customerStoryCaption17: "Sweden�?060 UV Printer",
    customerStoryCaption18: "Germany�?030 UV Printer",
    customerStoryCaption19: "South Africa�?030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "USA｜F70Pro DTF Printer",
    customerStoryCaption23: "USA�?513 UV Printer",
    customerStoryCaption24: "USA�?090 UV Printer",
    customerStoryCaption25: "USA�?030 UV Printer",
    customerStoryCaption26: "USA�?250 UV Printer",
    customerStoryCaption27: "South Korea�?060 UV Printer",
    customerStoryCaption28: "Netherlands�?060 UV Printer",
    catUvNav: "UV Flatbed",
    catCylinderNav: "Cylindrical",
    catCrystalNav: "Crystal Label",
    catDtfNav: "DTF",
    catDtgNav: "DTG",
    productA3220Subtitle: "Ultra Wide-Format Industrial UV Flatbed Solution",
    productA3220Feature1: "320×200cm Print Format",
    productA3220Feature2: "Visual Positioning System",
    productA3220Feature3: "Continuous Batch Production",
    productCrystal60UltraSubtitle: "Flagship Crystal Label Printing Solution",
    cityShanghai: "Shanghai",
    cityShenzhen: "Shenzhen",
    cityDetroit: "Detroit",
    cityManchester: "Manchester",
    cityStuttgart: "Stuttgart",
    cityDubai: "Dubai",
    cityPune: "Pune",
    cityOsaka: "Osaka",
    cityHoChiMinh: "Ho Chi Minh City",
    citySaoPaulo: "São Paulo",
    cityMelbourne: "Melbourne",
};
